var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isError ? _c('img', {
    attrs: {
      "src": _vm.img
    }
  }) : _c('LogoFallback');
}
var staticRenderFns = []

export { render, staticRenderFns }